import { profile } from '../common/service';
import Talent from './components/Talent';
import styles from './index.module.less';

function ServicePC() {
  const renderProfile = () => (
    <div className={styles.profile}>
      <img src={profile.bg} alt="" className={styles.profile__bg} />
      <div className={styles.profile__container}>
        <div className={styles.profile__title}>
          <div className={styles.profile__title__text}>{profile.label}</div>
          <div>{profile.subLabel}</div>
        </div>
        <div className={styles.profile__text}>{profile.content}</div>
      </div>
    </div>
  );

  return (
    <section className={styles.service}>
      {renderProfile()}
      <Talent />
    </section>
  );
}

export default ServicePC;
